import { formatNumber } from './digits';

/**
 * Money is an integer with **no minor unit**, thousands-separated, tabular, and
 * isolated in `<bdi>` at the render site.
 *
 * The currency word and the ISO code are **read from configuration** —
 * `CURRENCY` and `CURRENCY_ISO_CODE` on the owning service — and are never
 * hard-coded here. A formatter that knew the currency would be a second source
 * for a value the catalog already owns, and the catalog is the only authority.
 */

export interface MoneyLabels {
  /** Human-facing word, from the `CURRENCY` setting. */
  currency: string;
  /** Machine-facing ISO-4217 code, from the `CURRENCY_ISO_CODE` setting. */
  isoCode: string;
}

/** «١٥٬٠٠٠ <currency>» — the caller wraps the result in `<bdi>`. */
export function formatMoney(amount: number, labels: Pick<MoneyLabels, 'currency'>): string {
  return `${formatNumber(Math.trunc(amount))} ${labels.currency}`;
}

/** The machine half: an ASCII integer plus the configured ISO code. */
export function toMachineMoney(amount: number, labels: Pick<MoneyLabels, 'isoCode'>): string {
  return `${Math.trunc(amount)} ${labels.isoCode}`;
}
